export { default } from './useDebounce';

export type { UseDebounce } from './types';
